import 'core-js/stable';
import 'regenerator-runtime/runtime';
import 'custom-event-polyfill';
import React, { startTransition } from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import './scss/index.scss';
import AppComponent from './js/App';
import { history, store as createStore } from './js/redux/store';
import { actions as initialLoadActions } from './js/redux/ducks/initial-load';
import { preConnectTarget, isApp, isDarkMode } from './js/util/misc';

function getBackgroundImage(store) {
  if (store.getState().brand.background) {
    return store.getState().brand.background.default;
  }
  return '';
}

let root = null;

const render = () => {
  const darkModeToggle = store.getState()?.brand?.darkModeEnabled ?? true;

  const app = (
    <Provider store={ store }>
      <AppComponent history={ history } />
    </Provider>
  );

  if (!root) {
    root = createRoot(document.getElementById('root'));
  }

  startTransition(() => {
    root.render(app);
  });
  let hideEvent = {};

  let backgroundImageURL;

  if (isApp()) {
    backgroundImageURL = '';
  } else if (isDarkMode(darkModeToggle)) {
    backgroundImageURL = '';
  } else {
    backgroundImageURL = getBackgroundImage(store);
  }

  hideEvent = new CustomEvent('hide', {
    detail: { backgroundImageURL },
  });

  if (hideEvent !== null && document.getElementById('loading') !== null) {
    document.getElementById('loading').dispatchEvent(hideEvent);
  }

  preConnectTarget();
};

const store = createStore(render);
const synergyConfig = window.SynergConfig;
store.subscribe(() => {
  const state = store.getState();
  const darkModeEnabled = state.brand?.darkModeEnabled;
  const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches;

  if (darkModeEnabled && synergyConfig && prefersDark) {
    if (typeof synergyConfig.setMode === 'function') {
      synergyConfig.setMode('one-dark')
        .then(() => {
          console.log('Synergy theme switched to one-dark via setTheme');
        });
    }
  }
});
const { initialLoad } = initialLoadActions;

store.dispatch(initialLoad());
